import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
    mutation StripeCheckoutSessionMutation($input: Stripe__CheckoutSessionInput!) {
        stripeCheckoutSession(input: $input) {
            sessionId
            error
        }
    }
`;

const commit = input =>
  createMutation({
    mutation,

    variables: {
      input
    }
  });

export default { commit };
